import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonSlides, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-carrousel',
  templateUrl: './carrousel.page.html',
  styleUrls: ['./carrousel.page.scss'],
})
export class CarrouselPage implements OnInit, OnDestroy {
  @ViewChild('carrouselSlide') carrouselSlide: IonSlides;
  public carrousel: any[];
  public type: string;
  public index: any = 0;
  public length: any;
  private _subscription: Subscription = new Subscription();
  private _redirectPath =
    this._route.snapshot.queryParamMap.get('redirectPath');

  constructor(
    private paramSv: ParamServicesService,
    private navCtrl: NavController,
    @Inject(PLATFORM_ID) private platformId: any,
    private _route: ActivatedRoute
  ) {}

  async ngOnInit() {
    try {
      if (!isPlatformBrowser(this.platformId)) {
        return false;
      }

      const carrousel = localStorage.getItem('carrousel');
      if (carrousel === '1') {
        return this.navCtrl.navigateForward('home');
      }
      let images: any = await this.paramSv.getOnlyParam('carrousel');
      if (images) {
        this.carrousel = JSON.parse(images);
        const matches = window.matchMedia('(min-width: 500px)').matches;
        this.setMatchImages(matches);
        window
          .matchMedia('(min-width: 500px)')
          .addEventListener('change', (e) => {
            const matches = e.matches;
            this.setMatchImages(matches);
          });
        this.length = this.carrousel.length;
        if (!this.length) {
          this.skip();
          return;
        }
      } else {
        this.skip();
        return;
      }

      setTimeout(() => {
        this._subscription.add(
          this.carrouselSlide.ionSlideDidChange.subscribe(async () => {
            this.index = await this.carrouselSlide.getActiveIndex();
          })
        );
      });
      // Si el carrousel indica que el registro es obligatorio, lo guardo en el storage
      // para comprobar su estado siempre que se ingrese a la pagina y asi redireccionarlo al login
      // this.type = this.carrousel?.type;
      const data = await this.paramSv.getOnlyParam('redirectTo');
      this.type = JSON.parse(data);
    } catch (err) {
      this.skip();
      console.error(err);
    }
  }

  setMatchImages(matches) {
    this.carrousel.map((item) => {
      item.url = matches
        ? item.file || item.web.file
        : item.smallFile || item.movil.file;
    });
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  async skip() {
    try {
      if (this._redirectPath === '/') this._redirectPath = '/home';
      const isLogined = localStorage.getItem('logined');

      localStorage.setItem('carrousel', '1');

      const carrousel = '1';
      if (isLogined === '1' && carrousel === '1') {
        return this.navCtrl.navigateRoot('home');
      }
      if (this.type === 'requiredAuth' || this.type === 'auth') {
        this.navCtrl.navigateRoot('auth');
      } else {
        if (this._redirectPath) {
          this.navCtrl.navigateRoot(this._redirectPath);
        } else {
          this.navCtrl.navigateRoot('home');
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async slideTo(direction) {
    if (this.length - 1 === this.index && direction === 'next') {
      await this.skip();
    }
    direction === 'next'
      ? await this.carrouselSlide.slideNext(500)
      : await this.carrouselSlide.slidePrev(500);
  }
}
